import React, { useState } from "react";

const months = ["M0", "M1", "M2", "M3", "M4", "M5"];

function getColor(val) {
  if (val === null) return { bg: "var(--color-muted)", text: "var(--color-text-secondary)" };
  if (val >= 85) return { bg: "#D1FAE5", text: "#059669" };
  if (val >= 75) return { bg: "#DBEAFE", text: "#1E40AF" };
  if (val >= 65) return { bg: "#FEF3C7", text: "#D97706" };
  return { bg: "#FEE2E2", text: "#DC2626" };
}

export default function RetentionCohort({ cohortData: cohortDataProp }) {
  const [hovered, setHovered] = useState(null);
  const rows = cohortDataProp || [];

  return (
    <div
      className="rounded-xl border"
      style={{
        background: "var(--color-card)",
        borderColor: "var(--color-border)",
        boxShadow: "var(--shadow-md)",
        padding: "20px",
      }}
    >
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>
            Retention Cohort Analysis
          </h3>
          <p className="font-caption text-xs mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            Monthly retention rates by acquisition cohort
          </p>
        </div>
        <div className="flex items-center gap-2">
          {[
            { label: "≥85%", bg: "#D1FAE5", text: "#059669" },
            { label: "75-84%", bg: "#DBEAFE", text: "#1E40AF" },
            { label: "65-74%", bg: "#FEF3C7", text: "#D97706" },
            { label: "<65%", bg: "#FEE2E2", text: "#DC2626" },
          ]?.map((l) => (
            <div key={l?.label} className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-sm" style={{ background: l?.bg, border: `1px solid ${l?.text}` }} />
              <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>{l?.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs font-caption" style={{ minWidth: 400 }}>
          <thead>
            <tr>
              <th
                className="text-left pb-2 pr-3 font-semibold"
                style={{ color: "var(--color-text-secondary)", width: 80 }}
              >
                Cohort
              </th>
              {months?.map((m) => (
                <th key={m} className="text-center pb-2 px-1 font-semibold" style={{ color: "var(--color-text-secondary)" }}>
                  {m}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.map((row) => (
              <tr key={row?.cohort}>
                <td className="py-1 pr-3 font-medium" style={{ color: "var(--color-foreground)" }}>
                  {row?.cohort}
                </td>
                {months?.map((m, i) => {
                  const key = `m${i}`;
                  const val = row?.[key] ?? row?.retention?.[m] ?? null;
                  const { bg, text } = getColor(val);
                  const cellId = `${row?.cohort}-${m}`;
                  return (
                    <td key={m} className="py-1 px-1 text-center">
                      <div
                        className="rounded-md flex items-center justify-center font-data font-medium transition-all duration-150 cursor-default"
                        style={{
                          background: bg,
                          color: text,
                          height: 32,
                          minWidth: 44,
                          fontSize: "0.7rem",
                          transform: hovered === cellId ? "scale(1.1)" : "scale(1)",
                          boxShadow: hovered === cellId ? "var(--shadow-md)" : "none",
                        }}
                        onMouseEnter={() => setHovered(cellId)}
                        onMouseLeave={() => setHovered(null)}
                      >
                        {val !== null ? `${val}%` : "—"}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}